export enum SkillType {
   OTHER = "OTHER",
   FOCUS = "FOCUS",
  }
  